module.exports = __webpack_public_path__ + "iphone18pro-burgundy.17159ac7.png";